<template>
  <v-app dark>
    <navigation-drawer/>
    <main-toolbar/>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import MainToolbar from '@/components/MainToolbar.vue';
import NavigationDrawer from '@/components/NavigationDrawer.vue';
import '@/scss/app.scss';
import '../node_modules/nprogress/nprogress.css';

export default {
  name: 'App',
  components: {
    NavigationDrawer,
    MainToolbar,
  },
  data() {
    return {
      title: 'Avans Task Manager',
    };
  },
  beforeCreate() {
    this.$store.dispatch('bindUsers');
    this.$store.dispatch('bindStories');
    this.$store.dispatch('bindSprints');
  },
};
</script>
